import http from "../../../../../../core/utils/apis/skillApi";

const SkillMatrixByUserService = {
  searchUsersByName: (query) =>
    http.get(`/users/search/${query}`),

  getSkillsByUser: (userId) =>
    http.get(`/skills-reports/${userId}/skills`),

};

export default SkillMatrixByUserService;
